export default __webpack_public_path__ + "static/media/dots_pattern.fe1c0912.svg";